module.exports = __webpack_public_path__ + "static/media/solopreneur-banner.ca7e4dd6.jpg";